function HeadDhaxal ({data}){
    console.log(data)
    return (
        <>
            <div className="header_dhaxal">
                <div className="in_head_dhaxal">
                    <div className="image_uuse">
                    <img src={data && data.image} alt="user" />
                    </div>
                    <div className="macluumadd_user">
                        <div className="name_and_job">
                            <h2>{data && data.Name}</h2>
                            <p>{data && data.Nooc_akoon}</p>
                        </div>
                    </div>
                    <div className="btn_xidh">
                        <button> Xidho <i className="fa-solid fa-arrow-right-to-bracket"></i></button>
                    </div>
                </div>
            </div>
        </>
    )
}


export default HeadDhaxal